import { defineComponent, ref, computed } from 'vue';
import { ApplyNewService } from '@/services/applyNew.service';
import { useService } from '@kaokei/use-vue-service';
export default defineComponent({
  name: 'ApplyBanner',
  setup: function () {
    var applyService = useService(ApplyNewService);
    var ruleVisible = ref(false);
    var regPageConfig = computed(function () {
      return applyService.item.regPageConfig || {};
    });
    return {
      applyService: applyService,
      ruleVisible: ruleVisible,
      regPageConfig: regPageConfig
    };
  }
});